import { render, staticRenderFns } from "./SetOptionItem.vue?vue&type=template&id=dd45a82c&scoped=true"
import script from "./SetOptionItem.vue?vue&type=script&lang=js"
export * from "./SetOptionItem.vue?vue&type=script&lang=js"
import style0 from "./SetOptionItem.vue?vue&type=style&index=0&id=dd45a82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd45a82c",
  null
  
)

export default component.exports